var map = {
	"./avatar.svg": 9777,
	"./body0.png": 4606,
	"./body1.png": 4699,
	"./body2.png": 1307,
	"./feet0.png": 4746,
	"./feet1.png": 467,
	"./feet2.png": 2256,
	"./feet3.png": 5123,
	"./hair0.png": 492,
	"./hair1.png": 1789,
	"./hair2.png": 5016,
	"./hair3.png": 837,
	"./hair4.png": 7596,
	"./hair5.png": 6140,
	"./hat0.png": 3303,
	"./hat1.png": 6709,
	"./hat2.png": 7846,
	"./hat3.png": 7434,
	"./legs0.png": 8485,
	"./legs1.png": 241,
	"./legs2.png": 2297,
	"./legs3.png": 6278,
	"./torso0.png": 2767,
	"./torso1.png": 2701,
	"./torso2.png": 6759,
	"./torso3.png": 4573,
	"./torso4.png": 5178,
	"./torso5.png": 4904
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3706;